(function () {
    'use strict';

    angular.module('app.widgets')
        .component('asyncSearch', {
            bindings: {
                label: '@',
                placeholder: '@',
                type: '@',
                model: '<',
                required: '<',
                disabled: '<',
                onSearch: '&',
                onChange: '&',
                onLeave: '&',
                displayValue: '@',
                showNoResults: '<',
                form: '<'
            },
            controller: AsyncSearchController,
            controllerAs: 'vm',
            templateUrl: 'app/widgets/async-search/async.search.component.html'
        });

    /* @ngInject */
    function AsyncSearchController() {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.thisModel = '';
        vm.originalValue = null;

        vm.search = search;
        vm.onSelect = onSelect;
        vm.reValidate = reValidate;
        vm.onKeyUp = onKeyUp;

        function onChanges(changes) {
            if (changes.model) {
                vm.thisModel = changes.model.currentValue[vm.displayValue];
                setOriginalValue(vm.thisModel);
            }
        }

        function onInit() {
            vm.showNoResults = vm.showNoResults || true;            
            vm.thisModel = vm.model[vm.displayValue];
            setOriginalValue(vm.thisModel);
            vm.model = angular.extend(vm.model, { hasSelection: false });
        }

        function reValidate() {
            if (vm.onLeave !== undefined) {
                vm.onLeave();
            }            
        }

        function onKeyUp() {
            if (vm.originalValue && vm.originalValue === vm.thisModel) {
                return;
            }

            vm.model.hasSelection = false;
            reValidate();
        }

        function search(searchValue) {
            vm.thisModel = searchValue;
            setOriginalValue(vm.thisModel);
            return vm.onSearch({ searchValue: searchValue });
        }

        function onSelect(item, model, label, event) {
            vm.thisModel = label;
            setOriginalValue(vm.thisModel);
            model.hasSelection = true;
            vm.onChange({ model: model });

            if (vm.form) {
                vm.form[vm.label].$setPristine();
                vm.form[vm.label].$setUntouched();
                vm.form[vm.label].$invalid = false;
                vm.form[vm.label].$setValidity(vm.type, null);
            }
        }

        function setOriginalValue(value) {
            vm.originalValue = angular.copy(value);
        }
    }
})();
